import WeightedAverageInterface from "@app/Interface/WeightedAverageInterface";

export default class WeightedAverageModel implements WeightedAverageInterface {
    RcdID?: string | undefined;
    FieldRepID?: string | undefined;
    ProducerID: number;
    MonthYear_PK: Date;
    Weight: number;
    Fat: number;
    Protein: number;
    Lactose: number;
    SNF: number;
    Leuc: number;
    OtherSolids: number;
    AshFactor: number;
    MUN: number;
    AvgRaw: string;
    AvgPI: string;

    constructor (data?: WeightedAverageInterface) {
        this.RcdID = data?.RcdID ?? "";
        this.FieldRepID = data?.FieldRepID ?? "";
        this.ProducerID = data?.ProducerID ? Number(data?.ProducerID) : 0;
        this.MonthYear_PK = data?.MonthYear_PK ? new Date(data?.MonthYear_PK) : new Date();
        this.Weight = data?.Weight ? Number(data?.Weight) : 0;
        this.Fat = data?.Fat ? Number(data?.Fat) : 0;
        this.Protein = data?.Protein ? Number(data?.Protein) : 0;
        this.Lactose = data?.Lactose ? Number(data?.Lactose) : 0;
        this.SNF = data?.SNF ? Number(data?.SNF) : 0;
        this.Leuc = data?.Leuc ? Number(data?.Leuc) : 0;
        this.OtherSolids = data?.OtherSolids ? Number(data?.OtherSolids) : 0;
        this.AshFactor = data?.AshFactor ? Number(data?.AshFactor) : 0;
        this.MUN = data?.MUN ? Number(data?.MUN) : 0;
        this.AvgRaw = data?.AvgRaw ?? "";
        this.AvgPI = data?.AvgPI ?? "";
    }
    
}